module.exports = __webpack_public_path__ + "static/media/city3.bade0f80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/utils/images/dropdown-header/city3.jpg
// module id = 531
// module chunks = 0